
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Typography, Select, MenuItem, OutlinedInput, Checkbox, FormControl, Snackbar, Box, InputLabel, FormHelperText, ListItemText, TextField, Button } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Icon } from "@iconify/react";
import { ecosytemIntegatorMetaData, countryMetaData, ecosytemIntegatorCreateOrUpdate, ecosytemIntegatorGetById } from '../ecosystemPartners.service';
import Loader from '../../../components/loader';
import { EcosytemIntegratorConstants } from '../../../constant/ecosystem/ecosystemConst';
import { ecosystemIntegratorSchema } from '../validationschema';

export const EcosystemPartnersCreation = () => {
  const location = useLocation();
  const { id } = useParams();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const type = queryParams.get("type");
  const { ECOSYSTEMCREATION } = EcosytemIntegratorConstants()
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [countryData, setCountryData] = useState([]);
  const [countryCodeData, setCountryCodeData] = useState([]);
  const [country, setCountry] = useState('');
  const [openAlert, setOpenAlert] = useState(false);
  const [alert, setAlert] = useState('');
  const [responseMsg, setResponseMsg] = useState("");
  const [solutionData, setSolutionData] = useState([]);
  const [integatorType, setIntegatorType] = useState([]);
  const ALERT_DURATION = 2000;

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const alertClose = () => {
    setAlert('')
  }

  useEffect(() => {
    if (type === 'edit') {
      setEditMode(true);
    }
    ecosytemMetaData()
    countriesData()
    fetchData()
  }, [type, editMode]);

  const fetchData = async () => {
    if (editMode === true) {
      const getItem = ecosytemIntegatorGetById(id).then(async (res) => {
        let ecosystemData = res.data;
        setValue('ecosystemIntegratorName', ecosystemData?.integratorUser?.[0]?.ecosystemIntegratorName ? ecosystemData.integratorUser?.[0]?.ecosystemIntegratorName : '');
        setValue('countryId', ecosystemData?.integratorUser?.[0]?.countryId ? ecosystemData.integratorUser?.[0]?.countryId : '');
        setValue('countryCode', ecosystemData?.countryCode ? ecosystemData.countryCode : '');
        setValue('integratorType', ecosystemData?.integratorUser?.[0]?.integratorType ? ecosystemData.integratorUser?.[0]?.integratorType : '');
        setValue('email', ecosystemData?.email ? ecosystemData.email : '');
        setValue('phoneNumber', ecosystemData?.phoneNumber ? ecosystemData.phoneNumber : '');
        setValue('solutionIds', ecosystemData?.integratorUser?.[0]?.integratorSolution?.map((u) => u.id) || []);
      })
    }
  };

  const ecosytemMetaData = async () => {
    ecosytemIntegatorMetaData().then((res) => {
      if (res.statusCode === 200) {
        setSolutionData(res.data.solutionManagementList);
        setIntegatorType(res.data.integratorTypeList);
      }
    })
  }

  const countriesData = async () => {
    countryMetaData().then((res) => {
      if (res.statusCode === 200) {
        const countryManagementList = res.data.map(item => item.countryManagement);
        setCountryData(countryManagementList);
        setCountryCodeData(countryManagementList);
      }
    });
  };


  const { handleSubmit, formState: { errors }, control, setValue } = useForm({
    resolver: zodResolver(ecosystemIntegratorSchema)
  });

  
  const handleChange = (event) => {
    const selectedCountryId = event.target.value;
    setCountry(selectedCountryId);
  
    const selectedCountry = countryData.find(c => c.id === selectedCountryId);
    if (selectedCountry) {
      setValue('countryCode', selectedCountry.phoneCode || '', { shouldValidate: true });
    } else {
      setValue('countryCode', '', { shouldValidate: true });
    }
  };

  const onSubmit = async (data) => {
    try {
      setLoading(true)
      ecosytemIntegatorCreateOrUpdate(data, editMode, id).then((res) => {
        if (res.statusCode === 201 || res.statusCode === 200) {
          setResponseMsg(res.message);
          setAlert('true');
          setOpenAlert(true)
          setLoading(false)
          setTimeout(() => {
            editMode
              ? navigate(`/ecosystemPartnersView/${id}?type=edit`)
              : navigate('/ecosystemPartners');
            alertClose();
          }, ALERT_DURATION);
        } else if (res.statusCode === 404) {
          setResponseMsg(res.message);
          setAlert('false');
          setOpenAlert(true)
          setLoading(false)
          setTimeout(() => {
            alertClose();
          }, ALERT_DURATION);
        } else if (res.statusCode === 500 || res.statusCode === 400 || res.statusCode === 429) {
          setResponseMsg(res.message);
          setAlert('false');
          setOpenAlert(true)
          setLoading(false)
          setTimeout(() => {
            alertClose();
          }, ALERT_DURATION);
        }
        else {
          setResponseMsg(res.message);
          setAlert('false');
          setLoading(false)
          setOpenAlert(true)
          setTimeout(() => {
            alertClose()
          }, ALERT_DURATION);
        }
      })
    } catch (error) {
      setResponseMsg('Something went wrong. Please try again later.');
      setAlert('false');
      setOpenAlert(true);
      setLoading(false);
      setTimeout(() => {
        alertClose();
      }, ALERT_DURATION);
    }
  };



  return (
    <>

      <Grid container alignItems={'center'}>
        <Grid size={{ xs: 11, sm: 11, md: 11, lg: 11, xl: 11 }}>
          <Typography className='headingAlign'> {editMode ? "Update Ecosystem Integrators" : "Add New Ecosystem Integrators"}</Typography>
          <Typography mt={0.5}>{ECOSYSTEMCREATION.PARAGRAPH}</Typography>

        </Grid>
        <Grid size={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }} textAlign={'end'}>
          <Icon icon="ei:arrow-left"
            onClick={() => {
              editMode
                ? navigate(`/ecosystemPartnersView/${id}?type=edit`)
                : navigate('/ecosystemPartners');
            }} width="30" height="30" style={{ color: '#285D54', cursor: 'pointer' }}
          />
        </Grid>

      </Grid>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container columnGap={6} mt={2}>
          <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
            <Grid container mt={3}>
              <Typography mb={1} >{ECOSYSTEMCREATION.LABEL_ONE} <span style={{ color: 'var(--red-color)' }}>*</span> </Typography>
              <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <FormControl fullWidth>
                  <Controller name="ecosystemIntegratorName" control={control} defaultValue=""
                    render={({ field, fieldState: { error } }) => (
                      <TextField {...field} id="ecosystemIntegratorName" placeholder="Enter the integrator" onChange={(e) => {
                        const value = e.target.value;
                        const onlyText = value.replace(/[^a-zA-Z\s]/g, '');
                        field.onChange(onlyText);
                      }} type="text" variant="outlined" error={!!error} helperText={error ? error.message : ''} />)} />
                </FormControl>
              </Grid>
            </Grid>

            <Grid container mt={3}>
              <Typography mb={1} >{ECOSYSTEMCREATION.LABEL_TWO}  <span style={{ color: 'var(--red-color)' }}>*</span> </Typography>
              <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <FormControl fullWidth>
                  <InputLabel id="countryId-select-label">{ECOSYSTEMCREATION.SELECT_LABEL_ONE}</InputLabel>
                  <Controller name="countryId" control={control} defaultValue=""
                    render={({ field, fieldState: { error } }) => (
                      <Select labelId="countryId-select-label" id="countryId-select" label='Select the country' {...field} error={!!error} helperText={error ? error.message : ''} onChange={(e) => {
                        field.onChange(e);
                        handleChange(e);
                      }}>
                        <MenuItem value="" disabled>{ECOSYSTEMCREATION.SELECT_LABEL_ONE}</MenuItem>
                        {countryData.map((data) => (
                          <MenuItem key={data.name} value={data.id}>
                            {data.name}
                          </MenuItem>
                        ))}
                      </Select>)} />
                  {!!errors.countryId && (<FormHelperText error>{errors.countryId.message}</FormHelperText>)}
                </FormControl>
              </Grid>
            </Grid>
          </Grid>

          <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
            <Grid container mt={3}>
              <Typography mb={1}>{ECOSYSTEMCREATION.LABEL_THREE} <span style={{ color: 'var(--red-color)' }}>*</span> </Typography>
              <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <FormControl fullWidth>
                  <InputLabel id="country-select-label">{ECOSYSTEMCREATION.SELECT_LABEL_TWO}</InputLabel>
                  <Controller name="integratorType" control={control} defaultValue=""
                    render={({ field, fieldState: { error } }) => (
                      <Select labelId="integratorType-select-label" id="integratorType-select" label='Select integrator type' value={country} onChange={handleChange} {...field} error={!!error} helperText={error ? error.message : ''}>
                        <MenuItem value="" disabled>{ECOSYSTEMCREATION.SELECT_LABEL_TWO}</MenuItem>
                        {Object.entries(integatorType).map(([code, name]) => (
                          <MenuItem key={code} value={code}>
                            {name}
                          </MenuItem>
                        ))}
                      </Select>)} />
                  {!!errors.integratorType && (<FormHelperText error>{errors.integratorType.message}</FormHelperText>)}
                </FormControl>
              </Grid>
            </Grid>

            <Grid container mt={3}>
              <Typography mb={1}>{ECOSYSTEMCREATION.LABEL_FOUR}  <span style={{ color: 'var(--red-color)' }}>*</span> </Typography>
              <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <FormControl fullWidth error={!!errors.solutionIds}>
                  <Controller name="solutionIds" control={control} defaultValue={[]}
                    render={({ field }) => (
                      <Select labelId="solutionIds-label" id="solutionIds-select" multiple  {...field} value={field.value || []}
                        onChange={(event) => {
                          field.onChange(event.target.value);
                        }}
                        input={<OutlinedInput />}
                        renderValue={(selected) =>
                          selected
                            .map((id) => {
                              const user = solutionData.find((item) => item.id === id);
                              return user?.name || id;
                            })
                            .join(', ')
                        } MenuProps={MenuProps}>
                        {solutionData.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            <Checkbox checked={field.value.includes(item.id)} sx={{ padding: 0.3 }} />
                            <ListItemText>
                              <Typography sx={{ fontSize: 12 }}>{item.name}</Typography>
                            </ListItemText>
                          </MenuItem>
                        ))}
                        {solutionData.length === 0 && <MenuItem>No Options</MenuItem>}
                      </Select>
                    )} />
                  {!!errors.solutionIds && <FormHelperText>{errors.solutionIds.message}</FormHelperText>}
                </FormControl>
              </Grid>
            </Grid>
          </Grid>

          <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
            <Grid container mt={3}>
              <Typography mb={1} >{ECOSYSTEMCREATION.LABEL_FIVE}  <span style={{ color: 'var(--red-color)' }}>*</span> </Typography>
              <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <FormControl fullWidth>
                  <Controller name="email" control={control} defaultValue=""
                    render={({ field, fieldState: { error } }) => (
                      <TextField {...field} id="email" placeholder="Enter the email" type="text" variant="outlined" error={!!error} helperText={error ? error.message : ''} />)} />
                </FormControl>
              </Grid>
            </Grid>
          </Grid>

          <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}>
            <Grid container mt={3}>
              <Grid size={12}>
                <Typography mb={1}>
                  {ECOSYSTEMCREATION.LABEL_SIX}
                  <span style={{ color: 'var(--red-color)' }}>*</span>
                </Typography>
              </Grid>


              <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                <FormControl fullWidth error={!!errors.countryCode}>
                  <InputLabel id="countryCode-select-label">{ECOSYSTEMCREATION.SELECT_LABEL_THREE}</InputLabel>

                  <Controller name="countryCode" control={control} defaultValue=""
                    render={({ field, fieldState: { error } }) => (
                      <Select label='Country Code' labelId="countryCode-select-label" id="countryCode-select" value={field.value} onChange={field.onChange} error={!!error} helperText={error ? error.message : ""}>
                        <MenuItem value="" disabled>
                          {ECOSYSTEMCREATION.SELECT_LABEL_THREE}
                        </MenuItem>
                        {countryCodeData.map((data) => (
                          <MenuItem key={data.phoneCode} value={data.phoneCode}>
                            {data.countryFlag} {data.phoneCode}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  />
                  {!!errors.countryCode && (<FormHelperText error>{errors.countryCode.message}</FormHelperText>)}
                </FormControl>

              </Grid>

              <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                <FormControl fullWidth>
                  <Controller name="phoneNumber" control={control} defaultValue=""
                    render={({ field, fieldState: { error } }) => (
                      <TextField  {...field} id="phoneNumber" placeholder="Enter phone number" onInput={(e) => {
                        if (Number(e.target.value) < 0) {
                          e.target.value = e.target.value.replace("-", "");
                        }
                      }} inputProps={{ maxLength: 10 }} type="number" variant="outlined" error={!!error} helperText={error ? error.message : ""} />
                    )}
                  />
                </FormControl>
              </Grid>
            </Grid>

          </Grid>
        </Grid>

        <Grid container mb={2} mt={40} >
          <Grid size={10}>
            <Button variant="contained" className='resetbtn' onClick={() => { navigate('/ecosystemPartners') }} style={{ display: editMode ? 'none' : 'block' }} >Cancel</Button>
          </Grid>
          <Grid size={2} textAlign={'end'}>
            <Button variant="contained" className='createBtn' type="submit">{editMode ? "Update Integrator" : "Create Integrator"}</Button>
          </Grid>
        </Grid>
      </form>

      {loading && <Loader />}

      <Grid item xs={4} textAlign={'end'}>
        {(alert === 'true') && (
          <Snackbar open={openAlert} autoHideDuration={6000} onClose={alertClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                bgcolor: '#B6FFC3',
                py: 1.5,
                px: 2,
                borderRadius: '30px',
                boxShadow: 3,
                maxWidth: 400,
                mr: -5
              }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10 20C9 20 8.25 19.1667 7.66667 18.5C7.33333 18.1667 7 17.75 6.83333 17.6667C6.58333 17.5833 6 17.5833 5.58333 17.5833C4.66667 17.6667 3.66667 17.6667 3 17C2.33333 16.3333 2.33333 15.25 2.41667 14.4167C2.41667 13.9167 2.5 13.4167 2.33333 13.1667C2.25 12.9167 1.83333 12.5833 1.5 12.3333C0.833333 11.75 0 11 0 10C0 9 0.833333 8.25 1.5 7.66667C1.83333 7.33333 2.25 7 2.33333 6.83333C2.41667 6.58333 2.41667 6 2.41667 5.58333C2.33333 4.66667 2.33333 3.66667 3 3C3.66667 2.33333 4.75 2.33333 5.58333 2.41667C6.08333 2.41667 6.58333 2.5 6.83333 2.33333C7.08333 2.25 7.41667 1.83333 7.66667 1.5C8.25 0.833333 9 0 10 0C11 0 11.75 0.833333 12.3333 1.5C12.6667 1.83333 13 2.25 13.1667 2.33333C13.4167 2.41667 14 2.41667 14.4167 2.41667C15.3333 2.33333 16.3333 2.33333 17 3C17.6667 3.66667 17.6667 4.75 17.5833 5.58333C17.5833 6.08333 17.5 6.58333 17.6667 6.83333C17.75 7.08333 18.1667 7.41667 18.5 7.66667C19.1667 8.25 20 9 20 10C20 11 19.1667 11.75 18.5 12.3333C18.1667 12.6667 17.75 13 17.6667 13.1667C17.5833 13.4167 17.5833 14 17.5833 14.4167C17.6667 15.3333 17.6667 16.3333 17 17C16.3333 17.6667 15.25 17.6667 14.4167 17.5833C13.9167 17.5833 13.4167 17.5 13.1667 17.6667C12.9167 17.75 12.5833 18.1667 12.3333 18.5C11.75 19.1667 11 20 10 20ZM6.25 15.9167C6.66667 15.9167 7.08333 16 7.5 16.0833C8.08333 16.3333 8.58333 16.8333 9 17.3333C9.33333 17.75 9.83333 18.25 10.0833 18.25C10.3333 18.25 10.8333 17.75 11.1667 17.3333C11.5833 16.8333 12.0833 16.3333 12.6667 16.0833C13.25 15.8333 14 15.8333 14.6667 15.9167C15.1667 15.9167 15.8333 16 16 15.8333C16.1667 15.6667 16.0833 15 16.0833 14.5C16 13.8333 16 13.0833 16.25 12.5C16.5 11.9167 17 11.4167 17.5 11C17.8333 10.75 18.3333 10.25 18.3333 10C18.3333 9.75 17.8333 9.25 17.4167 8.91667C16.9167 8.5 16.4167 8 16.1667 7.41667C15.9167 6.83333 15.9167 6.08333 16 5.41667C16 4.91667 16.0833 4.25 15.9167 4.08333C15.75 3.91667 15.0833 4 14.5833 4C13.9167 4.08333 13.1667 4.08333 12.5833 3.83333C12 3.58333 11.5 3.08333 11.0833 2.58333C10.75 2.16667 10.25 1.66667 10 1.66667C9.75 1.66667 9.25 2.16667 8.91667 2.58333C8.5 3.08333 8 3.58333 7.41667 3.83333C6.83333 4.08333 6.08333 4.08333 5.41667 4C4.91667 4 4.25 3.91667 4.08333 4.08333C3.91667 4.25 4 4.91667 4 5.41667C4.08333 6.08333 4.08333 6.83333 3.83333 7.41667C3.58333 8 3.08333 8.5 2.58333 8.91667C2.16667 9.25 1.66667 9.75 1.66667 10C1.66667 10.25 2.16667 10.75 2.58333 11.0833C3.08333 11.5 3.58333 12 3.83333 12.5833C4.08333 13.1667 4.08333 13.9167 4 14.5833C4 15.0833 3.91667 15.75 4.08333 15.9167C4.25 16.0833 4.91667 16 5.41667 16C5.66667 16 5.91667 15.9167 6.25 15.9167ZM9.16667 13.6667L6.08333 10.5833L7.25 9.41667L9.16667 11.3333L13.5833 6.91667L14.75 8.08333L9.16667 13.6667Z" fill="#00AD5E" />
              </svg> &nbsp;&nbsp;
              <Typography
                sx={{ color: '#004d40', fontWeight: 600, fontSize: '0.95rem', flexGrow: 1, }}>
                {responseMsg}
              </Typography>
            </Box>
          </Snackbar>
        )}

        {(alert === 'false') && (
          <Snackbar open={openAlert} autoHideDuration={6000} onClose={alertClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                bgcolor: '#FDEDED',
                py: 1.5,
                px: 4,
                borderRadius: '30px',
                boxShadow: 3,
                maxWidth: 400,
                mr: -2
              }}
            >
              <Icon icon="solar:close-circle-linear" width="26" height="26" style={{ color: 'var(--red-color)' }} /> &nbsp;&nbsp;
              <Typography
                sx={{
                  color: '#DA342E',
                  fontWeight: 600,
                  fontSize: '0.95rem',
                  flexGrow: 1,
                }}>
                {responseMsg}
              </Typography>
            </Box>
          </Snackbar>
        )}
      </Grid>
    </>
  )
}

